module.exports = __webpack_public_path__ + "img/0Q3B1621-26_H_L_Foamcore.f35a5d6f.jpg";